import {
    ColumnType,
    FileUploadRes,
    MediaType,
    yascClassDescription,
    yascClassDisplayName,
    yascClassFormLayout,
    yascClassFormSectionTitle,
    yascDisplayName,
    yascEntityName,
    yascEnum,
    yascField,
    yascFileUpload,
    yascFormGrid,
    yascFormIgnore,
    yascFormKind,
    yascFormRows,
    yascFormSubsection,
    yascMaxLength,
    yascOptionsKey,
    yascRequired,
    yascTableColumn,
    yascTableIgnore,
    yascTableIndex,
    yascTableWidth,
} from '@yasc/yasc-material-components';
import {ProjectContractStatus} from '../../../enums/project-contract';

@yascEntityName('projectContractEntity')
@yascClassDisplayName('projectContractEntity')
@yascClassFormSectionTitle('projectContractFormTitle')
@yascClassDescription('projectContractFormDescription')
@yascClassFormLayout({columns: 2, gap: '12px'})
export class ProjectContract {
    @yascField()
    @yascTableIgnore(true)
    @yascFormIgnore()
    id = 0;

    @yascField()
    @yascDisplayName('projectContractNumber')
    @yascTableIndex(0)
    @yascTableColumn(ColumnType.Text)
    @yascTableWidth(150)
    @yascRequired()
    @yascMaxLength(100)
    @yascFormSubsection('projectContractSectionGeneral')
    @yascFormGrid({row: 1, width: 1})
    contractNumber = '';

    @yascField()
    @yascDisplayName('general_name')
    @yascTableIndex(1)
    @yascTableColumn(ColumnType.Text)
    @yascTableWidth(220)
    @yascRequired()
    @yascMaxLength(150)
    @yascFormSubsection('projectContractSectionGeneral')
    @yascFormGrid({row: 1, width: 1})
    name = '';

    @yascField()
    @yascDisplayName('general_customer')
    @yascTableIgnore(true)
    @yascFormKind('autocomplete')
    @yascOptionsKey('projectContractCustomers')
    @yascRequired()
    @yascFormSubsection('projectContractSectionAssignment')
    @yascFormGrid({row: 1, width: 1})
    customerId: number | null = null;

    @yascField()
    @yascDisplayName('general_customer')
    @yascTableIndex(2)
    @yascTableColumn(ColumnType.Text)
    @yascTableWidth(220)
    @yascFormIgnore()
    customerName = '';

    @yascField()
    @yascDisplayName('general_project')
    @yascTableIgnore(true)
    @yascFormKind('autocomplete')
    @yascOptionsKey('projectContractProjects')
    @yascFormSubsection('projectContractSectionAssignment')
    @yascFormGrid({row: 1, width: 1})
    projectId: number | null = null;

    @yascField()
    @yascDisplayName('general_project')
    @yascTableIndex(3)
    @yascTableColumn(ColumnType.Text)
    @yascTableWidth(220)
    @yascFormIgnore()
    projectName = '';

    @yascField()
    @yascDisplayName('projectContractStart')
    @yascTableIndex(5)
    @yascTableColumn(ColumnType.Date)
    @yascFormKind('date')
    @yascRequired()
    @yascFormSubsection('projectContractSectionTerm')
    @yascFormGrid({row: 1, width: 1})
    start?: string;

    @yascField()
    @yascDisplayName('projectContractEnd')
    @yascTableIndex(6)
    @yascTableColumn(ColumnType.Date)
    @yascFormKind('date')
    @yascFormSubsection('projectContractSectionTerm')
    @yascFormGrid({row: 1, width: 1})
    end?: string;

    @yascField()
    @yascDisplayName('general_status')
    @yascTableIndex(4)
    @yascTableColumn(ColumnType.Select)
    @yascEnum(ProjectContractStatus, 'projectContractStatusEnum')
    @yascFormKind('select')
    @yascRequired()
    @yascFormSubsection('projectContractSectionGeneral')
    @yascFormGrid({row: 2, width: 1})
    status: ProjectContractStatus = ProjectContractStatus.Draft;

    @yascField()
    @yascDisplayName('projectContractDocument')
    @yascTableIgnore(true)
    @yascFileUpload({mediaType: MediaType.Document, allowMultiUpload: false, maxFileSizeMb: 25})
    @yascFormSubsection('projectContractSectionDocument')
    @yascFormGrid({row: 1, width: 2, fullRow: true})
    document: FileUploadRes | null = null;

    @yascField()
    @yascDisplayName('projectContractBudgetCount')
    @yascTableIndex(7)
    @yascTableColumn(ColumnType.Number)
    @yascFormIgnore()
    budgetCount = 0;

    @yascField()
    @yascDisplayName('general_description')
    @yascTableIgnore(true)
    @yascFormKind('textarea')
    @yascFormRows(4)
    @yascMaxLength(1000)
    @yascFormSubsection('projectContractSectionAdditional')
    @yascFormGrid({row: 1, width: 2, fullRow: true})
    comment = '';

    constructor(init: Partial<ProjectContract> = {}) {
        Object.assign(this, init);
    }
}
